import React from 'react';
import PropTypes from 'prop-types';
import TooltipTrigger from 'react-popper-tooltip';

export default class Info extends React.Component {
  Tooltip = ({ getTooltipProps, tooltipRef }) => {
    return (
      <div {...getTooltipProps({ ref: tooltipRef, className: 'tooltip-container _z_index_20000' })}>
        {this.props.popperElement}
      </div>
    );
  };

  Trigger = ({ getTriggerProps, triggerRef }) => (
    <div {...getTriggerProps({ ref: triggerRef, className: `trigger ${this.props.triggerWrapperClassName}` })}>
      {this.props.triggerElement}
    </div>
  );

  render() {
    return (
      <TooltipTrigger placement='right-start' trigger='hover' tooltip={this.Tooltip}>
        {this.Trigger}
      </TooltipTrigger>
    );
  }
}

Info.propTypes = {
  triggerElement: PropTypes.element,
  popperElement: PropTypes.element,
  triggerWrapperClassName: PropTypes.string,
};

Info.defaultProps = {
  triggerElement: <div />,
  popperElement: <div />,
  triggerWrapperClassName: '',
};



// WEBPACK FOOTER //
// ./src/app/Components/Info.jsx